<template>
  <div class="admin-page">
    <h1 class="title">Panou administrare</h1>

    <!-- 🔸 Schimbare parolă -->
    <div class="topbar-right">
      <div class="password-field">
        <input
          :type="showPassword ? 'text' : 'password'"
          v-model="newPassword"
          placeholder="Noua parolă"
          class="password-input"
        />
        <button class="toggle-btn" @click="showPassword = !showPassword">
          <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
        </button>
      </div>

      <div class="password-field">
        <input
          :type="showConfirm ? 'text' : 'password'"
          v-model="confirmPassword"
          placeholder="Confirmă parola"
          class="password-input"
        />
        <button class="toggle-btn" @click="showConfirm = !showConfirm">
          <i :class="showConfirm ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
        </button>
      </div>

      <button class="change-pass-btn" @click="changePassword">
        Schimbă parola
      </button>
    </div>

    <div class="admin-container">
      <!-- Sidebar -->
      <aside class="sidebar">
        <h3>SERVICII</h3>

        <ul>
          <li
            v-for="service in services"
            :key="service"
            :class="{ active: selectedService === service }"
            @click="selectService(service)"
          >
            {{ service }}
          </li>
        </ul>

        <button class="logout-btn" @click="logout">Logout</button>
      </aside>

      <!-- Conținut principal -->
      <main class="main-content">
        <div class="upload-section">
          <h2>{{ selectedService }}</h2>
          <input
            type="file"
            multiple
            accept="image/*"
            @change="handleFileUpload"
          />
        </div>

        <!-- Galerie imagini -->
        <div v-if="images.length" class="gallery">
          <div v-for="(img, index) in images" :key="index" class="image-card">
            <img :src="img.url" alt="Imagine" @error="removeImage(index)" />
            <button class="delete-btn" @click="deleteImage(img.name)">✖</button>
          </div>
        </div>

        <p v-else class="no-images">
          Nu există imagini pentru această secțiune.
        </p>

        <!-- Editor text servicii -->
        <AdminContentEditor :service="serviceFolder(selectedService)" />
      </main>
    </div>

    <transition name="fade">
      <p v-if="message" class="message">{{ message }}</p>
    </transition>
  </div>
</template>

<script>
import AdminContentEditor from "@/components/AdminContentEditor.vue";

export default {
  name: "Admin",
  components: { AdminContentEditor },

  data() {
    return {
      services: [
        "Gallery",
        /* "Colantare",*/
        "Detailing",
        /* "FoliiSolare",*/
        "Lumini",
        "Panoramic",
        "Polish",
        /*  "PPF",
        "Retapitari",*/
        "Vopsirepiele",
        "Mentenanta",
      ],
      selectedService: "Gallery",
      images: [],
      message: "",

      newPassword: "",
      confirmPassword: "",
      showPassword: false,
      showConfirm: false,
    };
  },

  mounted() {
    this.fetchImages();
  },

  methods: {
    // Mapare serviciu UI -> folder backend
    serviceFolder(serviceName) {
      const map = {
        Gallery: "gallery",
        Colantare: "colantare",
        Detailing: "detailing",
        FoliiSolare: "foliisolare",
        Lumini: "lumini",
        Panoramic: "panoramic",
        Polish: "polish",
        PPF: "ppf",
        Retapitari: "retapitari",
        Vopsirepiele: "vopsirepiele",
        Mentenanta: "mentenanta",
      };
      return map[serviceName] || String(serviceName || "").toLowerCase();
    },

    // ✅ IMPORTANT: folosim aceeași origine (merge perfect cu Nginx proxy)
    apiBase() {
      return ""; // => /api/... și /uploads/...
    },

    authHeaders(extra = {}) {
      const token = localStorage.getItem("adminToken") || "";
      return {
        Authorization: token,
        ...extra,
      };
    },

    selectService(service) {
      this.selectedService = service;
      this.fetchImages();
    },

    // === IMAGINI ===
    async fetchImages() {
      const folder = this.serviceFolder(this.selectedService);

      try {
        const res = await fetch(`${this.apiBase()}/api/gallery/${folder}`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const files = await res.json();

        this.images = Array.isArray(files)
          ? files.map((url) => ({
              name: url.split("/").pop(),
              url: `${this.apiBase()}${url}`, // url e deja /uploads/...
            }))
          : [];
      } catch (err) {
        console.error("❌ Eroare la încărcarea imaginilor:", err);
        this.images = [];
      }
    },

    async handleFileUpload(e) {
      const files = e.target.files;
      if (!files || !files.length) return;

      const folder = this.serviceFolder(this.selectedService);
      const formData = new FormData();

      for (let f of files) formData.append("images", f);

      // dacă backend-ul tău chiar folosește req.body.categorie, o lăsăm:
      formData.append("categorie", folder);

      try {
        const res = await fetch(`${this.apiBase()}/api/upload/${folder}`, {
          method: "POST",
          headers: this.authHeaders(), // fără Content-Type (FormData)
          body: formData,
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        await this.fetchImages();
        this.message = "✔️ Upload reușit!";
      } catch (err) {
        console.error("❌ Upload error:", err);
        this.message = "❌ Upload eșuat.";
      } finally {
        e.target.value = "";
        setTimeout(() => (this.message = ""), 2000);
      }
    },

    async deleteImage(filename) {
      if (!confirm("Ștergi imaginea?")) return;

      const folder = this.serviceFolder(this.selectedService);

      try {
        const res = await fetch(
          `${this.apiBase()}/api/delete/${folder}/${encodeURIComponent(
            filename
          )}`,
          {
            method: "DELETE",
            headers: this.authHeaders(),
          }
        );

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        await this.fetchImages();
        this.message = "🗑️ Imagine ștearsă!";
      } catch (err) {
        console.error("❌ Delete error:", err);
        alert("Eroare la ștergere imagine.");
      } finally {
        setTimeout(() => (this.message = ""), 2000);
      }
    },

    removeImage(i) {
      this.images.splice(i, 1);
    },

    // === AUTENTIFICARE ===
    logout() {
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("adminToken");
      this.$router.push("/login");
    },

    async changePassword() {
      if (!this.newPassword.trim() || !this.confirmPassword.trim()) {
        alert("Completează ambele câmpuri de parolă!");
        return;
      }

      if (this.newPassword !== this.confirmPassword) {
        alert("Parolele nu coincid!");
        return;
      }

      try {
        const response = await fetch(`${this.apiBase()}/api/change-password`, {
          method: "POST",
          headers: this.authHeaders({ "Content-Type": "application/json" }),
          body: JSON.stringify({
            oldPass: localStorage.getItem("adminToken"),
            newPass: this.newPassword,
          }),
        });

        const data = await response.json();

        if (data.success) {
          alert("✅ Parola a fost schimbată cu succes!");
          localStorage.setItem("adminToken", this.newPassword);
          this.newPassword = "";
          this.confirmPassword = "";
          this.logout();
        } else {
          alert(data.message || "Eroare la schimbarea parolei.");
        }
      } catch (err) {
        console.error("Eroare:", err);
        alert("Eroare de conexiune la server.");
      }
    },
  },
};
</script>

<style scoped>
.admin-page {
  color: #fff;
  background-color: #000;
  min-height: 100vh;
  padding: 2rem;
}

.title {
  text-align: center;
  color: goldenrod;
  margin-bottom: 1rem;
}

.admin-container {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.sidebar {
  width: 200px;
  background: #111;
  padding: 1rem;
  border-radius: 8px;
  height: fit-content;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar li {
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  margin-bottom: 4px;
  transition: background 0.2s;
}

.sidebar li.active,
.sidebar li:hover {
  background: goldenrod;
  color: #000;
}

.logout-btn {
  margin-top: 1rem;
  width: 100%;
  background: #c0392b;
  border: none;
  color: white;
  padding: 0.6rem 1rem;
  border-radius: 6px;
  cursor: pointer;
}

.main-content {
  flex: 1;
  padding: 1rem;
}

.topbar-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.7rem;
  margin-bottom: 1rem;

  background-color: #111;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #333;
  width: 240px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}

/* === Câmpuri parolă === */
.password-field {
  position: relative;
  width: 100%;
}

.password-input {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 40px 8px 12px;
  border-radius: 6px;
  border: 1px solid #555;
  background-color: #000;
  color: #fff;
  font-size: 0.95rem;
  outline: none;
  transition: 0.2s;
}

.password-input:focus {
  border-color: #facc15;
  box-shadow: 0 0 5px #facc15;
}

/* === Iconiță ochi === */
.toggle-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #facc15;
  font-size: 1rem;
  line-height: 1;
  z-index: 2;
}

.toggle-btn:hover {
  color: #ffe580;
}

/* === Buton Schimbă parola === */
.change-pass-btn {
  width: 100%;
  background: #facc15;
  color: #000;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  transition: background 0.2s;
}

.change-pass-btn:hover {
  background: #ffdf4d;
}

/* === Galerie === */
.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
  margin-top: 1rem;
}

.image-card {
  position: relative;
}

.image-card img {
  width: 100%;
  border-radius: 8px;
  display: block;
}

.delete-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.no-images {
  text-align: center;
  color: #aaa;
}

.message {
  text-align: center;
  color: goldenrod;
  margin-top: 1rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
